import { render, staticRenderFns } from "./VariableMappingPanel.vue?vue&type=template&id=09fc4c79"
import script from "./VariableMappingPanel.vue?vue&type=script&lang=js"
export * from "./VariableMappingPanel.vue?vue&type=script&lang=js"
import style0 from "./variable-mapping.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports